import { render, staticRenderFns } from "./warehouseItemDetail.vue?vue&type=template&id=0aec4f12&scoped=true&"
import script from "./warehouseItemDetail.vue?vue&type=script&lang=js&"
export * from "./warehouseItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./warehouseItemDetail.vue?vue&type=style&index=0&id=0aec4f12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec4f12",
  null
  
)

export default component.exports